export default "__VITE_ASSET__CRcHgV7W__"